import {
  CREATE_SUBSCRIBE,
  GET_SUBSCRIBE,
  GET_SUBSCRIBES,
  SET_ALL_SUBSCRIBES,
  SET_ALL_SUBSCRIBE_SELECT,
  UPDATE_SUBSCRIBE,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
};

const subscribeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_SUBSCRIBES:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_SUBSCRIBES:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_SUBSCRIBE_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.title}`,
          price: data.price,
        });
      });
      return {
        ...state,
        selectData: selectData,
      };
    case CREATE_SUBSCRIBE:
      return {
        ...state,
        getData: action.payload,
      };
    case GET_SUBSCRIBE:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_SUBSCRIBE:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default subscribeReducer;
